import { useTranslation } from 'react-i18next';

const WhyUsSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-gift-line',
      title: t('home:whyUs.free.title'),
      description: t('home:whyUs.free.description'),
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      icon: 'ri-flashlight-line',
      title: t('home:whyUs.fast.title'),
      description: t('home:whyUs.fast.description'),
      color: 'text-teal-600',
      bgColor: 'bg-teal-100'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('home:whyUs.secure.title'),
      description: t('home:whyUs.secure.description'),
      color: 'text-orange-600',
      bgColor: 'bg-orange-100'
    },
    {
      icon: 'ri-user-smile-line',
      title: t('home:whyUs.easy.title'),
      description: t('home:whyUs.easy.description'),
      color: 'text-pink-600',
      bgColor: 'bg-pink-100'
    }
  ];

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('home:whyUs.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('home:whyUs.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group hover:scale-105 transition-transform duration-300">
              <div className={`w-20 h-20 ${feature.bgColor} rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform`}>
                <i className={`${feature.icon} text-4xl ${feature.color}`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-50 to-green-50 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">{t('home:whyUs.cta.title')}</h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">{t('home:whyUs.cta.description')}</p>
          <a
            href="#tools"
            className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            {t('home:whyUs.cta.button')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
